import { render, staticRenderFns } from "./dept-input.vue?vue&type=template&id=f782918c&scoped=true"
import script from "./dept-input.vue?vue&type=script&lang=js"
export * from "./dept-input.vue?vue&type=script&lang=js"
import style0 from "./dept-input.vue?vue&type=style&index=0&id=f782918c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f782918c",
  null
  
)

export default component.exports